// Copyright (c) 2025-2026 NacenCheck — TracePro Compliance-Grade Trace OS.
// Licensed under the MIT License — see LICENSE file in the repo root.
// SPDX-License-Identifier: MIT

"use client";

import React from "react";
import { LocaleProvider } from "@tracepro/hooks";

export function RootLocaleProvider({ children }: { children: React.ReactNode }) {
  return <LocaleProvider>{children}</LocaleProvider>;
}
